import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lib-friendly-message',
  templateUrl: './friendly-message.component.html',
  styleUrls: ['./friendly-message.component.css']
})
export class FriendlyMessageComponent implements OnInit {

  @Input() public data: any;
  @Input() public settings: any;

  constructor() { }

  messageDismissed: boolean;

  ngOnInit() {
    this.messageDismissed = false;
  }

  dismissMessage(){
    this.messageDismissed = true;
  }

}
